import vue from "vue";

export const fetchMarketList = async (city) => {
  const res = await vue.axios.get(
    `/catalog/api/catalog/read/catalog/filter?isCategory=y&city=${city}`,
  );
  return res.data.response;
};

export const fetchNewStores = async (payload) => {
  const res = await vue.axios.post(`/cap/users/partner/nearby`, payload);
  return res.data;
};

export const fetchAllItems = async (payload) => {
  const res = await vue.axios.post(`/home/list/all`, payload);
  return res.data;
};

export const fetchNewArrival = async (payload) => {
  const res = await vue.axios.post("/home/list/new-arrivals", payload);
  return res.data;
};

export const getBillPaymentCategory = async (payload) => {
  const res = await vue.axios.get(
    `/catalog/api/catalog/read/catalog/tree-public?market=${payload}`,
  );
  return res.data.response;
};
export const tenantConfigApi = async () => {
  return await vue.axios.post(`/cap/users/tenant/get-config`, {});
};
export const tenantPreferenceApi = async (id) => {
  return await vue.axios.get(`/cap/users/tenant/get-preferences/${id}`);
};
export const paymentConfigApi = async (tenantId) => {
  return await vue.axios.get(`/payments/config/get/${tenantId}`);
};
export const tenaDetailsById = async (tenantId) => {
  return await vue.axios.get(`/cap/users/tenant/detail-by-id/${tenantId}`);
};
export const storeListApi = async (payload) => {
  return await vue.axios.post(`cap/users/partner/org-partner-list`, payload);
};
export const storeChatList = async () => {
  return await vue.axios.get(`notification/bschat/chat-contacts/list`);
};
